import React, { Component } from "react";
import TrackingArtwork from "../trackingArtwork";

class assignedMap extends Component {
  render() {
    const { booking } = this.props;

    return (
      <TrackingArtwork
        isMaxService={booking?.trip?.service?.isMaxService}
        title="Tracking Unavailable"
        subtitle="Please refresh again later"
      />
    );
  }
}

export default assignedMap;
